import { render, staticRenderFns } from "./CompareQuestions.vue?vue&type=template&id=33f32322&scoped=true"
import script from "./CompareQuestions.vue?vue&type=script&lang=js"
export * from "./CompareQuestions.vue?vue&type=script&lang=js"
import style0 from "./CompareQuestions.vue?vue&type=style&index=0&id=33f32322&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f32322",
  null
  
)

export default component.exports